import { render, staticRenderFns } from "./ReviewCard.vue?vue&type=template&id=6f5b5e62&scoped=true&"
import script from "./ReviewCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReviewCard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ReviewCard.vue?vue&type=style&index=0&id=6f5b5e62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5b5e62",
  null
  
)

export default component.exports